/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import '../Calendar/activity-calendar.css';
import Moment from 'moment';
import { CALENDER_SCREEN, COMMON, API_CONSTANTS, ALL_ROUTES } from '../../global/Constants';
import { ActivityType } from "../../global/Enum";
import Header from '../common/Header';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import ActivityHeader from '../common/ActivityHeader';
import AcceptRejectButton from '../common/AcceptRejectButton';
import SyncServices from '../../providers/SyncServices';
import ViewOfflineImage from '../common/ViewOfflineImage';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';

class GroupMeetingView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            activity: null,
            data: null,
            address: "Fetching address..."
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.data;
                this.setState({ activity: activity });
                Utilities.LogPrint("Data:-->", activity);
                this.getActivityById(activity);

            } else {
                this.props.history.replace(ALL_ROUTES.CALENDAR_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    handleBack = () => {
        this.props.history.goBack();
    }

    getActivityById(data) {

        SyncServices.getActivityById("key", data.key).then(activity => {
            Utilities.LogPrint("getActivityById", activity);
            SyncServices.findKrishakFromDatabase("krishak_id", activity.krishak_id.toString()).then(data => {
                //Utilities.LogPrint("getActivityById", activity.krishak_id);
                activity.krishak = data;
                this.setState({ data: activity, address: activity.data?.address });
            });
        });
    }

    getAddressFromLatLong(latitude, longitude) {
        if (Utilities.isNetworkConnected()) {
            var body = JSON.stringify({
                latitude: latitude,
                longitude: longitude
            });
            try {
                ApiServices.getAddressFromLatLong(body).then(response => {
                    if (response.success) {
                        this.setState({ address: response.data.address });
                    } else {
                        this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
                    }
                }).catch(error => {
                    this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
                });
            } catch (error) {
                this.setState({ address: COMMON.LOCATION_ERROR_MESSAGE });
            }
        }
    }


    getFormattedDate() {
        let selectedDate = null;
        if (this.props.location.state !== undefined) {
            selectedDate = this.props.location.state.selectedDate;
            return Moment(selectedDate).format('dddd, DD MMM, yyyy');
        }
    }

    getTotalAttendNumbers() {
        const { data } = this.state;
        var total = parseInt(data.data?.no_farmer_attend) + parseInt(data.data?.no_retailer_attend) + parseInt(data.data?.no_prerak_attend);
        return total;
    }

    getTotalCommitment() {
        const { data } = this.state;

        var farmerCommitment = 0;
        farmerCommitment = 0 + parseInt(data?.data?.farmer_commitment);

        var retailerCommitmentTotal = 0;
        data.data?.retailer_commitment.forEach(function (obj) {
            retailerCommitmentTotal += parseInt(obj.commitment);
        });

        var prerakCommitmentTotal = 0;
        data.data?.prerak_commitment.forEach(function (obj) {
            prerakCommitmentTotal += parseInt(obj.commitment);
        });

        var total = farmerCommitment + retailerCommitmentTotal + prerakCommitmentTotal;
        return total;
    }


    getFarmerNumbers() {
        const { data } = this.state;
        let numbers = [];
        const farmerPhones = data.data?.group_meeting_farmer_phone;
        if (farmerPhones) {
            data?.data?.group_meeting_farmer_phone.forEach(function (item) {
                if (item?.is_phone === 1) {
                    numbers.push(item.phone_image);
                } else {
                    numbers.push(item.phone);
                }
            })
        }
        return numbers;
    }

    handleAcceptButton = () => {
        this.props.history.goBack();
    }

    handleRejectButton = () => {
        this.props.history.goBack();
    }

    getAttendedBy() {
        const { data } = this.state;
        const attendsByData = [];

        attendsByData.push({
            type: "Farmers",
            number: data.data?.no_farmer_attend,
            commitment: data.data?.farmer_commitment,
            name: ""
        });


        for (let i = 0; i < data.data?.retailer_commitment.length; i++) {
            let retailer = data.data?.retailer_commitment[i];
            if (i === 0) {
                attendsByData.push({
                    type: "Retailers",
                    number: data.data?.no_retailer_attend,
                    commitment: retailer.commitment,
                    name: this.getRetailerById(retailer?.retailer_id)
                });
            } else {
                attendsByData.push({
                    type: "",
                    number: "",
                    commitment: retailer.commitment,
                    name: this.getRetailerById(retailer?.retailer_id)
                });
            }
        }


        for (let i = 0; i < data.data?.prerak_commitment.length; i++) {
            let prerak = data.data?.prerak_commitment[i];
            if (i === 0) {
                attendsByData.push({
                    type: "Preraks",
                    number: data.data?.no_prerak_attend,
                    commitment: prerak.commitment,
                    name: prerak.prerak_name
                });
            } else {
                attendsByData.push({
                    type: "",
                    number: "",
                    commitment: prerak.commitment,
                    name: prerak.prerak_name
                });
            }
        }
        return attendsByData;
    }


    _renderAttendedTable = () => {
        //this.getAttendedBy();
        if (this.getAttendedBy().length > 0) {
            return (
                <table className="table attendedby-table">
                    <tbody>
                        <tr>
                            <th>Type</th>
                            <th>Number</th>
                            <th>Commitment</th>
                            <th>Name</th>
                        </tr>

                        {/* <tr>
                            <td>Farmers</td>
                            <td>{data?.group_meeting?.no_farmer_attend}</td>
                            <td>{data?.group_meeting?.farmer_commitment} kg</td>
                            <td></td>
                        </tr> */}


                        {
                            this.getAttendedBy().length ?
                                this.getAttendedBy().map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.type}</td>
                                        <td>{item.number}</td>
                                        <td>{item.commitment} kg</td>
                                        <td>{item.name}</td>
                                    </tr>
                                )) : null
                        }

                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Total</td>
                            <td className="font-weight-medium">{this.getTotalAttendNumbers()}</td>
                            <td className="font-weight-medium">{this.getTotalCommitment()} kg</td>
                            <td></td>
                        </tr>
                    </tfoot>

                </table>
            )
        }

    }


    getRetailerById = (retailerId) => {
        const retailersArray = DataProvider.getInstance().getRetailers();
        Utilities.LogPrint("Retailers", retailersArray);
        if (retailersArray.length > 0) {
            let retailer = retailersArray.find(item => item.retailer_id === retailerId);
            //Utilities.LogPrint("Retailers", retailer);
            if (retailer !== null) {
                return retailer?.retailer_shop_name;
            }
        }
    }

    getEmployeeNameById = (userId) => {
        const employee = DataProvider.getInstance().getEmployeeById(userId);
        if (employee) {
            return employee.name;
        }
        return "";
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, isSyncLoading, tableName, activity, data, address } = this.state;
        if (data == null) {
            return (
                <div>
                    {isLoading ? <Loader /> : null}
                </div>
            );
        }

        const krishak = data?.krishak;
        const groupMeeting = data.data;



        //TODO As Per New Changes
        let name = '';
        let phone = '';
        let isVisibleName = false;
        if (krishak !== null) {
            name = krishak?.name;
            phone = krishak?.phone;
            isVisibleName = true;
        } else {
            if (groupMeeting?.host_name) {
                name = groupMeeting?.host_name;
                phone = groupMeeting?.host_phone;
                isVisibleName = true;
            }
        }

        return (
            <div>
                {/* <Header />
                <Footer isActive={1} /> */}
                <Header handleSyncLoading={this.handleSyncLoading} />
                <Footer isActive={2} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="title mb-0">{this.getFormattedDate()} Activities for {this.getEmployeeNameById(data.assigned_user_id)}</h3>
                            <p className="sub-title">{activity?.tehsil_name}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12 my-3">
                            <ActivityHeader
                                type={ActivityType.GROUP_MEETING}
                                code={activity?.activity_tag}
                                title={activity.activity_type_name}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />
                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn mt-3 d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBack}>{COMMON.BACK}</button>
                        </div>
                    </div>

                    {/* Reject Reason */}
                    {
                        data.activity_reject && data.activity_status_id === 4 ?
                            <div className="row">
                                <div className="col-12 reject-activity-msg">
                                    <i className="customic ic-rejected"></i>
                                    <span>{data?.activity_reject?.reject?.title}</span>
                                </div>
                            </div> : null
                    }

                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className={`col-12 col-md-4 ${isVisibleName ? "" : "d-none"}`}>
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">{CALENDER_SCREEN.FARMER_NAME}</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{name}</span>
                                            <span className="d-block font-weight-medium">+91 - {phone}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Stage of Visit</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{groupMeeting?.season?.season_name}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Sub Activity</div>
                                        <div className="col-8 col-md-12">
                                            <span className="d-block font-weight-medium">{(groupMeeting?.sub_activity.label !== undefined) ? groupMeeting?.sub_activity?.label : groupMeeting?.sub_activity?.sub_activity_name}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="row mb-3">
                                        <div className="col-4 col-md-12">Location</div>
                                        <div className="col-8 col-md-12">
                                            {/* <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span> */}
                                            <span className="d-block font-weight-medium">{address}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mx-md-0">
                                <hr className="w-100 bdr-color-gray m-0" />
                            </div>

                            <div className="row">
                                <div className="col-lg-12 d-md-none">
                                    <div className="row">
                                        <div className="col-12 px-sm-3">
                                            <h6 className="font-weight-medium mt-3">Attended by</h6>

                                            <div className="row mb-2">
                                                <div className="col-4">
                                                    <span className="d-block">Farmers</span>
                                                    <span className="d-block font-weight-medium">{groupMeeting?.no_farmer_attend}</span>
                                                </div>
                                                <div className="col-8">
                                                    <span className="d-block">Commitment</span>
                                                    <span className="d-block font-weight-medium">{groupMeeting?.farmer_commitment} kg</span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-4">
                                                    <span className="d-block">Retailers</span>
                                                    <span className="d-block font-weight-medium">{groupMeeting?.no_retailer_attend}</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="d-block">Commitment</span>
                                                    {/* <span className="d-block font-weight-medium">10 kg</span> */}
                                                    {
                                                        groupMeeting?.retailer_commitment.length ?
                                                            groupMeeting?.retailer_commitment.map((item, i) => (
                                                                <span key={i} className="d-block font-weight-medium">{item.commitment} Kg</span>
                                                            )) : null
                                                    }

                                                </div>
                                                <div className="col-4">
                                                    <span className="d-block">Name</span>
                                                    {/* <span className="d-block font-weight-medium">Retailer One</span> */}
                                                    {
                                                        groupMeeting?.retailer_commitment.length ?
                                                            groupMeeting?.retailer_commitment.map((item, i) => (
                                                                <span key={i} className="d-block font-weight-medium">{this.getRetailerById(item?.retailer_id)}</span>
                                                            )) : null
                                                    }

                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-4">
                                                    <span className="d-block">Prerak</span>
                                                    <span className="d-block font-weight-medium">{groupMeeting?.no_prerak_attend}</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="d-block">Commitment</span>
                                                    {/* <span className="d-block font-weight-medium">10 kg</span>
                                                    <span className="d-block font-weight-medium">10 kg</span> */}
                                                    {
                                                        groupMeeting?.prerak_commitment.length ?
                                                            groupMeeting?.prerak_commitment.map((item, i) => (
                                                                <span key={i} className="d-block font-weight-medium">{item.commitment} Kg</span>
                                                            )) : null
                                                    }
                                                </div>
                                                <div className="col-4">
                                                    <span className="d-block">Name</span>
                                                    {/* <span className="d-block font-weight-medium">Prerak One</span>
                                                    <span className="d-block font-weight-medium">Prerak Two</span> */}
                                                    {
                                                        groupMeeting?.prerak_commitment.length ?
                                                            groupMeeting?.prerak_commitment.map((item, i) => (
                                                                <span key={i} className="d-block font-weight-medium">{item?.prerak_name}</span>
                                                            )) : null
                                                    }

                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-4 offset-4">
                                                    <span className="d-block">Total</span>
                                                    <span className="d-block font-weight-medium">{this.getTotalCommitment()} kg</span>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <hr className="w-100 bdr-color-gray m-0" />
                                            </div>

                                            <div className="krishak-info">
                                                <a className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#collapseFarmersMobileNumbers" aria-expanded="true" aria-controls="collapseFarmersMobileNumbers">Farmers Mobile Numbers<i className="customic ic-down-arrow ml-auto"></i></a>
                                                <div className="row">
                                                    <hr className="w-100 bdr-color-gray" />
                                                </div>

                                                <div className="col-12 px-sm-3 px-0 pending-act-body mb-3 collapse show" id="collapseFarmersMobileNumbers">
                                                    <div className="row mb-3">
                                                        {/* <div className="col-4">Mobile Numbers</div> */}

                                                        <div className="col-8">
                                                            <span className="d-block font-weight-medium">{this.getFarmerNumbers().join(",  ")}</span>
                                                        </div>

                                                        {/* {
                                                            data?.group_meeting_farmer_phone !== null ?
                                                                data?.group_meeting_farmer_phone.map((item, i) => (
                                                                    <div className="col-8">
                                                                        <span className="d-block font-weight-medium">{this.getFarmerNumbers().join(",  ")}</span>
                                                                    </div>
                                                                )) : null
                                                        } */}
                                                    </div>

                                                    {/* Farmer Number Images */}
                                                    <div className="row mb-3">
                                                        {
                                                            groupMeeting?.group_meeting_farmer_image ?
                                                                groupMeeting?.group_meeting_farmer_image.map((item, i) => (
                                                                    <ViewOfflineImage key={i} image={item.image_url} />
                                                                )) : null
                                                        }
                                                    </div>


                                                    <div className="row">
                                                        <hr className="w-100 bdr-color-gray" />
                                                    </div>
                                                </div>

                                                {groupMeeting?.remark.length > 0 ?
                                                    <div>
                                                        <span className="d-flex w-100 align-items-center mt-3">{COMMON.REMARKS}</span>
                                                        <span className="d-flex font-weight-medium mb-3">{groupMeeting.remark}</span>

                                                    </div> : null

                                                }

                                                <div className="row">
                                                    <hr className="w-100 bdr-color-gray" />
                                                </div>

                                                <span className="font-weight-medium d-flex w-100 align-items-center mt-3 mb-2">{COMMON.IMAGES}</span>
                                                <div className="row row7-5 mb-3">
                                                    {
                                                        groupMeeting?.group_meeting_image.length ?
                                                            groupMeeting?.group_meeting_image.map((item, i) => (
                                                                <ViewOfflineImage key={i} image={item.image_url} />
                                                            )) : null
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-12 d-none d-md-block">
                                    <h6 className="font-weight-medium mt-4">Attended by</h6>
                                    {this._renderAttendedTable()}


                                    {/* <div className="form-group d-flex align-items-center">
                                        <label className="mb-0 mr-3 text-gray">Farmer Mobile Numbers</label>
                                        <input type="text" className="form-control max-w-360" placeholder="" value={this.getFarmerNumbers().join(",  ")} disabled />
                                    </div> */}

                                    <div className="form-group">
                                        <label className="mr-3">Farmer Mobile Numbers</label>
                                        <span className="d-block font-weight-medium">{this.getFarmerNumbers().join(",  ")}</span>
                                    </div>

                                    {/* Farmer Images */}
                                    <div className="row">
                                        {
                                            groupMeeting?.group_meeting_farmer_image.length ?
                                                groupMeeting?.group_meeting_farmer_image.map((item, i) => (
                                                    <div key={i} className="col-md-2 image-info group-meeting">
                                                        <img src={item.image_url} alt="" />
                                                    </div>
                                                )) : null
                                        }

                                    </div>

                                    {/* Remarks */}
                                    <div className="form-group mb-4">
                                        {groupMeeting?.remark.length > 0 ?
                                            <div>
                                                <span className="d-flex w-100 mt-2">{COMMON.REMARKS}</span>
                                                <span className="d-flex font-weight-medium mb-2">{groupMeeting.remark}</span>

                                                <div className="row mx-sm-0 d-md-none">
                                                    <hr className="w-100 bdr-color-gray m-0" />
                                                </div>
                                            </div> : null}
                                    </div>

                                    <div className="row mx-md-0">
                                        <hr className="w-100 bdr-color-gray m-0" />
                                    </div>

                                    <div className="row row7-5 mb-3 justify-content-end">
                                        <div className="col-12 col-md-7 col-lg-4">
                                            <span className="font-weight-medium d-flex w-100 align-items-center mt-3 mb-2">{COMMON.IMAGES}</span>
                                            <div className="row">
                                                {
                                                    groupMeeting?.group_meeting_image.length ?
                                                        groupMeeting.group_meeting_image.map((item, i) => (
                                                            <ViewOfflineImage key={i} image={item.image_url} />

                                                        )) : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <AcceptRejectButton
                        activity={activity}
                        handleAcceptButton={this.handleAcceptButton}
                        handleRejectButton={this.handleRejectButton}
                    />
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(GroupMeetingView);